var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMenuSensormanage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-menu-sensormanage",
    transform: "translate(-25.332 -997.639)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    width: 36,
    height: 36,
    transform: "translate(25.332 997.639)",
    fill: "#fff",
    opacity: 0.003
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon-menu-sensormanage-2",
    "data-name": "icon-menu-sensormanage",
    d: "M298.553,74H287.168a5.163,5.163,0,0,0-4.78,3.211,5.172,5.172,0,0,0-3.741,3.4,5.165,5.165,0,0,0-3.527,4.9v6.338a5.164,5.164,0,0,0,5.164,5.164h3.068l1.829,3.167a.908.908,0,0,0,1.572,0l1.829-3.167h3.086a5.165,5.165,0,0,0,4.9-3.528,5.178,5.178,0,0,0,3.145-2.945,5.165,5.165,0,0,0,4.005-5.032V79.164A5.165,5.165,0,0,0,298.553,74Zm-4.075,17.843a2.813,2.813,0,0,1-2.809,2.809H280.284a2.813,2.813,0,0,1-2.809-2.809V85.5a2.813,2.813,0,0,1,2.809-2.809h11.384a2.813,2.813,0,0,1,2.809,2.809Zm3.261-3.261a2.8,2.8,0,0,1-.906,2.061V85.5a5.165,5.165,0,0,0-5.164-5.164H281.484a2.8,2.8,0,0,1,2.061-.906H294.93a2.813,2.813,0,0,1,2.809,2.809Zm3.623-3.08a2.8,2.8,0,0,1-1.268,2.345v-5.6a5.165,5.165,0,0,0-5.164-5.164h-9.637a2.79,2.79,0,0,1,1.876-.725h11.384a2.813,2.813,0,0,1,2.809,2.809Z",
    transform: "translate(-246.087 928.325)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuSensormanage);
export default __webpack_public_path__ + "static/media/icon-menu-sensormanage.023659525d519a781cdb2be74990d64f.svg";
export { ForwardRef as ReactComponent };